<template>
  <div v-if="visible" class="modal-backdrop">

    <div class="modal-content">

      <h5 class="modal-title mb-3 text-center">
        Paiement de l'hospitalisation
      </h5>


      <div class="modal-body-scroll">

        <div class="row">


          <!-- ============================
               COLONNE GAUCHE
          ============================== -->

          <div class="col-md-6">


            <div class="mb-3">

              <label class="form-label">
                Montant total
              </label>

              <input
                type="number"
                class="form-control"
                :value="totalHospitalisation"
                disabled
              />

            </div>



            <div class="mb-3">

              <label class="form-label">
                Total déjà payé
              </label>

              <input
                type="number"
                class="form-control"
                :value="totalDejaPaye"
                disabled
              />

            </div>



            <div class="mb-3">

              <label class="form-label">
                Reste à payer
              </label>

              <input
                type="number"
                class="form-control"
                :value="resteReel"
                disabled
              />

            </div>




            <div class="mb-3">

              <label class="form-label">
                Montant versé
              </label>


              <input

                type="number"

                class="form-control"

                v-model.number="montantVerse"

                :max="resteReel"

                :disabled="resteReel <= 0"

              />


            </div>




            <div class="mb-3">

              <label class="form-label">
                Reste après paiement
              </label>


              <input

                type="number"

                class="form-control"

                :value="resteApresPaiement"

                disabled

              />


            </div>



          </div>






          <!-- ============================
               COLONNE DROITE
          ============================== -->


          <div class="col-md-6">



            <!-- CONTRAT ASSURANCE PATIENT -->

            <div class="mb-3">


              <label class="form-label">
                Assurance
              </label>



              <select

                class="form-control"

                v-model.number="contratAssuranceId"

              >


                <option :value="null">

                  Aucune assurance

                </option>




                <option

                  v-for="contrat in contratsAssurance"

                  :key="contrat.id"

                  :value="contrat.id"

                >


                  {{ contrat.assurance.nom }}

                  -

                  {{ contrat.numeroAssure }}

                  -

                  {{ contrat.tauxCouverture }} %


                </option>


              </select>



            </div>







            <!-- INFORMATION CONTRAT -->

            <div

              v-if="contratChoisi"

              class="alert alert-info"

            >


              <div>

                <strong>
                  Assurance :
                </strong>

                {{ contratChoisi.assurance.nom }}

              </div>


              <div>

                <strong>
                  Numéro assuré :
                </strong>

                {{ contratChoisi.numeroAssure }}

              </div>


              <div>

                <strong>
                  Couverture :
                </strong>

                {{ contratChoisi.tauxCouverture }} %

              </div>


            </div>







            <!-- PART ASSURANCE -->

            <div class="mb-3">


              <label class="form-label">
                Part Assurance
              </label>


              <input

                type="number"

                class="form-control"

                :value="partAssurance"

                disabled

              />


            </div>







            <!-- PART PATIENT -->

            <div class="mb-3">


              <label class="form-label">
                Part Patient
              </label>


              <input

                type="number"

                class="form-control"

                :value="partPatient"

                disabled

              />


            </div>








            <!-- MODE PAIEMENT -->


            <div class="mb-3">


              <label class="form-label">
                Mode de paiement *
              </label>



              <select

                class="form-control"

                v-model.number="modePaiementId"

              >


                <option :value="null">

                  -- Sélectionner --

                </option>




                <option

                  v-for="mode in modesPaiement"

                  :key="mode.id"

                  :value="mode.id"

                >

                  {{ mode.nom }}

                </option>



              </select>



            </div>



          </div>



        </div>



      </div>







      <!-- ============================
             BOUTONS
      ============================== -->


      <div class="d-flex justify-content-end mt-3">


        <button

          class="btn btn-secondary me-2"

          @click="close"

        >

          Annuler

        </button>





        <button

          class="btn btn-success"

          :disabled="isLoading"

          @click="payer"

        >


          <span v-if="isLoading">

            Chargement...

          </span>


          <span v-else>

            Enregistrer

          </span>



        </button>



      </div>




    </div>


  </div>
</template>
<script>
import api from "@/api";

export default {

  props: {

    visible: Boolean,

    hospitalisation: Object,

    patientId: Number,

  },


  data() {

    return {

      isLoading:false,


      // contrat assurance patient
      contratAssuranceId:null,

      contratsAssurance:[],


      // paiement
      modePaiementId:null,

      montantVerse:0,


      modesPaiement:[],


    };

  },



  computed:{



    currentUser(){

      return this.$store.getters.user;

    },



    /**
     * Montant total hospitalisation
     */
    totalHospitalisation(){


      return (

        this.hospitalisation
        ?.montantCalcule
        ?.montant

        ||

        0

      );


    },



    /**
     * Total déjà encaissé
     */
    totalDejaPaye(){


      return (

        this.hospitalisation
        ?.totalEncaisse

        ||

        0

      );


    },



    /**
     * Reste réel
     */
    resteReel(){


      const reste =

        this.totalHospitalisation

        -

        this.totalDejaPaye;



      return reste > 0 ? reste : 0;


    },






    /**
     * Contrat choisi par le patient
     */
    contratChoisi(){


      return this.contratsAssurance.find(

        c => c.id === this.contratAssuranceId

      )

      ||

      null;


    },







    /**
     * Part prise en charge assurance
     */
    partAssurance(){


      if(!this.contratChoisi)

        return 0;



      return Math.round(

        this.montantVerse

        *

        this.contratChoisi.tauxCouverture

        /

        100

      );


    },







    /**
     * Part patient
     */
    partPatient(){


      return (

        this.montantVerse

        -

        this.partAssurance

      );


    },








    /**
     * Reste après paiement
     */
    resteApresPaiement(){


      const reste =

        this.resteReel

        -

        this.montantVerse;



      return reste > 0 ? reste : 0;


    },




  },







  watch:{



    /**
     * Quand on change de contrat
     */
    contratAssuranceId(){


      this.montantVerse = 0;


    },




    /**
     * Quand le patient change
     */
    patientId(){


      this.fetchContratsAssurance();


    },




  },








  mounted(){


    this.fetchContratsAssurance();

    this.fetchModesPaiement();


  },








  methods:{





    /**
     * Chargement des contrats assurance du patient
     */
    async fetchContratsAssurance(){


      if(!this.patientId)

        return;



      try{


        const res = await api.getItem(

          "patients",

          `${this.patientId}/contrats-assurance`

        );



        /**
         * API retourne directement un tableau
         */
        this.contratsAssurance =

          res.data || [];



        console.log(

          "Contrats assurance patient",

          this.contratsAssurance

        );



      }

      catch(error){


        console.error(

          "Erreur chargement contrats assurance",

          error

        );


      }



    },








    /**
     * Modes paiement
     */
    async fetchModesPaiement(){


      try{


        const res = await api.getItems(

          "moyen_paiements"

        );


        this.modesPaiement =

          res.data.data || [];



      }

      catch(error){


        console.error(error);


      }


    },










    close(){


      this.$emit("fermer");


    },









    /**
     * Enregistrement paiement
     */
    async payer(){





      if(!this.modePaiementId){


        alert(

          "Sélectionnez un mode de paiement."

        );


        return;


      }







      if(this.montantVerse <=0){


        alert(

          "Montant invalide."

        );


        return;


      }







      /*if(this.montantVerse > this.resteReel){


        alert(

          "Le montant dépasse le reste à payer."

        );


        return;


      }*/








      const payload = {



        montant:this.montantVerse,



        hospitalisation:

          this.hospitalisation.id,



        patient:

          this.patientId,



        modePaiement:

          this.modePaiementId,




        /**
         * Contrat assurance patient
         * null si aucune assurance
         */
        contratAssurance:

          this.contratAssuranceId

          ?

          `/api/v1/contrat_assurance_patients/${this.contratAssuranceId}`

          :

          null,





        createdBy:

          this.currentUser.id,




        type:

          "hospitalisation",




        datePaiement:

          new Date().toISOString(),



      };





      console.log(

        "PAYLOAD",

        payload

      );





      this.isLoading=true;






      try{


        await api.createItem(

          "paiement_hospitalisations",

          payload

        );



        this.$emit(

          "paiementEffectue"

        );



        this.close();



      }



      catch(error){



        console.error(error);



        alert(

          "Erreur lors du paiement."

        );


      }



      finally{


        this.isLoading=false;


      }





    },






  },



};

</script>







<style scoped>


.modal-backdrop {

  position:fixed;

  inset:0;

  background:rgba(0,0,0,0.5);

  display:flex;

  align-items:center;

  justify-content:center;

  z-index:999;


}



.modal-content {


  background:white;

  padding:20px;

  border-radius:12px;

  width:800px;

  max-width:95%;

  max-height:90vh;

  display:flex;

  flex-direction:column;


}




.modal-body-scroll {


  overflow-y:auto;

  padding-right:5px;


}


</style>